module.exports = __webpack_public_path__ + "img/四川天府新区河畔新世界幼儿园.0b17e281.jpg";